var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfileDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16.5,
    r: 16.5,
    fill: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4605_16050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 33
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16.5,
    r: 16.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4605_16050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 19.7998C7.2318 19.7998 3.7998 24.7498 3.7998 28.0498V32.9998H30.1998V28.0498C30.1998 24.7498 26.7678 19.7998 16.9998 19.7998Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 18.1498C21.1009 18.1498 24.4252 14.8255 24.4252 10.7248C24.4252 6.62409 21.1009 3.2998 17.0002 3.2998C12.8995 3.2998 9.5752 6.62409 9.5752 10.7248C9.5752 14.8255 12.8995 18.1498 17.0002 18.1498Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileDummy);
export default __webpack_public_path__ + "static/media/User-profile-dummy.4bf25267b4a636cd1b3be12abb4c1a89.svg";
export { ForwardRef as ReactComponent };